import { refreshTokenWithLambda } from '../repository/authRepository';

export async function refreshAccessToken(): Promise<string | null> {
  try {
    const refreshToken = localStorage.getItem('refresh_token');
    if (!refreshToken) return null;

    const result = await refreshTokenWithLambda(refreshToken);
    if ('error' in result) {
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      return null;
    }

    localStorage.setItem('access_token', result.access);
    if (result.refresh) {
      localStorage.setItem('refresh_token', result.refresh);
    }
    return result.access;
  } catch {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    return null;
  }
}

export function isTokenExpired(bufferSeconds: number = 30): boolean {
  const accessToken = localStorage.getItem('access_token');
  if (!accessToken) return true;
  try {
    const payload = JSON.parse(atob(accessToken.split('.')[1]));
    return payload.exp < (Math.floor(Date.now() / 1000) + bufferSeconds);
  } catch {
    return true;
  }
}

export async function fetchWithAuth(url: string, options: RequestInit = {}): Promise<Response> {
  if (isTokenExpired()) {
    await refreshAccessToken();
  }

  const accessToken = localStorage.getItem('access_token');
  const headers: Record<string, string> = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,
    ...(options.headers as Record<string, string> || {}),
  };

  let response = await fetch(url, { ...options, headers });

  if (response.status === 401) {
    const newToken = await refreshAccessToken();
    if (newToken) {
      headers['Authorization'] = `Bearer ${newToken}`;
      response = await fetch(url, { ...options, headers });
    }
  }

  return response;
}

let refreshInterval: number | null = null;

export function setupAutoRefresh(): void {
  if (refreshInterval) clearInterval(refreshInterval);
  refreshInterval = window.setInterval(async () => {
    if (isTokenExpired(3600)) {
      await refreshAccessToken();
    }
  }, 3600000);
  if (isTokenExpired(3600)) {
    refreshAccessToken();
  }
}

export function clearAutoRefresh(): void {
  if (refreshInterval) {
    clearInterval(refreshInterval);
    refreshInterval = null;
  }
}
